angular.module('wco.directives.virtualKeyboard', [])
    .controller('WcoVirtualKeyboardController', ['$scope', function($scope) {

    }])
    .directive('wcoVirtualKeyboard', ['$timeout', function($timeout) {
        return {
            controller: 'WcoVirtualKeyboardController',
            controllerAs: 'VirtualKeyboardController',
            scope:{
                paramType: '=',
            },
            link: function(scope, element, attrs) {
                $timeout(() => {
                    let keyboardPosition = {
                        of: $('.keyboard-container'),
                        my: 'center top',
                        at: 'center top',
                        at2: 'center bottom'
                    };

                    let paramType = scope.paramType;
                    if (paramType === 'INTEGER' || paramType === 'TIME') {
                        $(element).keyboard({
                            layout: 'customnum',
                            autoAccept: true,
                            position: keyboardPosition
                        });
                    }
                    else if (paramType === 'VARCHAR') {
                        $(element).keyboard({
                            layout: 'customwebco',
                            autoAccept: true,
                            position: keyboardPosition
                        });
                    }
                    else if (paramType === 'DATE') {
                        $(element).keyboard({
                            layout: 'customnumwithpoint',
                            autoAccept: true,
                            position: keyboardPosition,
                            openOn: 'click'
                        });
                    }
                });
            }
        };
    }]);